import { IonCard, IonCardContent, IonRow } from '@ionic/react';
import { DqText } from '../../components/dq-text';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { JobReportGuestAuthMessages } from '../../intl/JobReportGuestAuthMessages';
import { formatTimestamp } from '../../utils/helpers/timeHelpers';

export interface ShareLinkExpiredCardProps {
  expiresAt: number;
}

export const ShareLinkExpiredCard: FC<ShareLinkExpiredCardProps> = ({ expiresAt }) => {
  const { formatMessage } = useIntl();

  return (
    <IonCard className="content-card">
      <IonCardContent className="ion-flex ion-align-items-start">
        <IonRow>
          <DqText variant="h3" color="dark">
            {formatMessage(JobReportGuestAuthMessages.shareLinkExpiredTitle)}
          </DqText>
        </IonRow>
        <IonRow>
          <DqText className="ion-margin-vertical" variant="body" color="dark">
            {formatMessage(JobReportGuestAuthMessages.shareLinkExpiredMessage, {
              expiresAt: formatTimestamp(expiresAt, navigator.language),
            })}
          </DqText>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};
